import React, {PureComponent} from 'react'
import SimpleFileForm from "../../../core/components/forms/file/SimpleFileForm";
import {PAGE_FILES} from "../../constants/PageConstant";
import {connect} from "react-redux";
import {fileFormSetFiles} from "../../../core/actions/FileFormActions";
import {openPage} from "../../actions/PageActions";

class FileButton extends PureComponent {

    handleFiles = (files) => {
        const {fileFormSetFiles} = this.props;
        fileFormSetFiles(files);
        this.finish();
    };

    finish = () => {
        this.props.openPage(PAGE_FILES);
    };

    render() {
        const {className, children} = this.props;

        return <SimpleFileForm handleFiles={this.handleFiles}>
            {(handleClick) => (
                <a onClick={handleClick} className={className}>{children}</a>
            )}
        </SimpleFileForm>;
    }
}

export default connect(
    state => ({}),
    dispatch => ({
        fileFormSetFiles: files => dispatch(fileFormSetFiles(files)),
        openPage: page => dispatch(openPage(page)),
    })
)(FileButton);